module.exports = __webpack_public_path__ + "img/magazin-header.53622beb.jpg";